import {Script} from 'gatsby'
import React, {useEffect, useState} from 'react'

export default function ScheduleTourSnippet(): JSX.Element {
  const [i18nLoaded, seti18nLoaded] = useState(false)
  const [uiLoaded, setUiLoaded] = useState(false)
  const [buttonExists, setButtonExists] = useState(false)

  useEffect(() => {
    /* Button is sticky across Gatsby pages, only load the scripts once */
    const buttonElement = document.getElementById('ppcb_btn')
    setButtonExists(Boolean(buttonElement))
  }, [])

  if (!buttonExists) {
    return (
      <>
        {/* Theses scripts have to load in order. */}
        <Script
          onLoad={() => seti18nLoaded(true)}
          src="//commoncdn.entrata.com/javascript/i18n/i18n.min.js"
          type="text/javascript"
        />
        {i18nLoaded && (
          <Script onLoad={() => setUiLoaded(true)} src="//commoncdn.entrata.com/javascript/i18n/entrata-ui.min.js" />
        )}
        {i18nLoaded && uiLoaded && (
          <Script type="text/javascript">{`
        !function(e){var t=document.createElement("script"),n=function(){ppcb.render({subdomain:"//prospectportal.culdesac.com",query:"is_responsive_snippet=1&snippet_type=contact_button"})};t.src="//commoncdn.entrata.com/website_templates/_assets/_common/contact_btn_controller.min.js?ver=1108616",t.defer=!0,t.async=!0,t.readyState?t.onreadystatechange=function(){("loaded"===t.readyState||"complete"===t.readyState)&&n()}:t.onload=n,document.head.appendChild(t)}(window);
      `}</Script>
        )}
      </>
    )
  } else {
    return <></>
  }
}
